export default () => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="28"
        width="28"
        height="28"
        rx="4"
        transform="rotate(90 28 0)"
        fill="#7D8DA6"
        fillOpacity="0.1"
      />
      <path
        d="M16.3333 8.16667L10.5 14.5833L16.3333 21"
        stroke="#7D8DA6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
